import React from "react";

type AuthLayoutProps = {
  children: React.ReactNode;
  backgroundUrl: string;
};

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, backgroundUrl }) => {
  return (
    <div className="h-full w-full font-primary relative flex items-center justify-center bg-left md:bg-center bg-cover bg-no-repeat"
      style={{ backgroundImage: `url(${backgroundUrl})` }}>
        <div className="relative z-10 flex flex-col items-center text-center w-full px-4">
            {children}
        </div>
    </div>
  );
};

export default AuthLayout;